import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { parseNumber } from 'src/utils/parsing';
import { getUserFilter } from 'src/models/TaskViewOptions';
var styles = {
    container: {
        display: 'flex'
    },
    select: {
        margin: '.2rem',
        border: '1px solid #ddd',
        width: '200px',
        outline: 'none',
        borderRadius: '3px',
        padding: '.25rem'
    },
    input: {
        margin: '.2rem',
        border: '1px solid #ddd',
        width: '200px',
        outline: 'none',
        borderRadius: '3px',
        padding: '.25rem .5rem'
    }
};
var TimeOverviewFilter = /** @class */ (function (_super) {
    tslib_1.__extends(TimeOverviewFilter, _super);
    function TimeOverviewFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectChange = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, this.props.store.load(parseNumber(e.target.value))];
                    case 1:
                        _a.sent();
                        if (this.props.onChange) {
                            this.props.onChange();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleTextChange = function (e) {
            e.preventDefault();
            _this.props.store.textFilter = e.target.value;
            if (_this.props.onChange) {
                _this.props.onChange();
            }
        };
        return _this;
    }
    TimeOverviewFilter.prototype.render = function () {
        return (React.createElement("div", { style: styles.container },
            this.renderUserFilter(),
            React.createElement("input", { style: styles.input, placeholder: "Sz\u0171r\u00E9s", value: this.props.store.textFilter, onChange: this.handleTextChange })));
    };
    TimeOverviewFilter.prototype.renderUserFilter = function () {
        if (!this.props.userStore.loggedInUserIsAdmin) {
            return null;
        }
        var selectFields = getUserFilter(this.props.taskStore.filter.viewOption)(this.props.userStore)
            .sort(function (a, b) { return a.name.localeCompare(b.name); })
            .map(function (i) { return (React.createElement("option", { key: i.id, value: i.id }, i.name)); });
        return (React.createElement("select", { placeholder: "Projekttag", style: styles.select, onChange: this.handleSelectChange }, selectFields));
    };
    TimeOverviewFilter = tslib_1.__decorate([
        inject('userStore', 'taskStore'),
        observer
    ], TimeOverviewFilter);
    return TimeOverviewFilter;
}(React.Component));
export default TimeOverviewFilter;



//////////////////
// WEBPACK FOOTER
// ./src/pages/timeoverview/TimeOverviewFilter.tsx
// module id = 785
// module chunks = 0